module.exports = __webpack_public_path__ + "img/logo_verde_celeste.7c3dcc0b.png";